import interestTravel from './interest/travel';
import interestSport from './interest/sport';

export default [interestTravel, interestSport];
